import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useExecuteQueryMutation } from "../redux/crmApi";
import { useSubmitCallingRequestMutation } from "../redux/crmApi";
import { useDispatch } from "react-redux";
import { logoutSuccess } from "../redux/crmAdminAuthSlice";

const ReporterLandingPage = () => {
  const [reasonForCalling, setReasonForCalling] = useState("");
  const [query, setQuery] = useState("");
  const [queryResults, setQueryResults] = useState([]);
  const [questions, setQuestions] = useState([""]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Number of items per page
  const navigate = useNavigate();
  const [executeQuery, { data, isLoading: isQueryLoading, error }] =
    useExecuteQueryMutation();
  const [submitCallingRequest, { isLoading: isSubmitLoading, isError }] =
    useSubmitCallingRequestMutation();
  const dispatch = useDispatch();

  // Mock player data (replace with API call)
  // const players = Array.from({ length: 100 }, (_, i) => ({
  //   player_id: i + 1,
  //   name: `Player ${i + 1}`,
  //   country_code: "US",
  //   phone: `123-456-${String(i + 1).padStart(4, "0")}`,
  //   score: Math.floor(Math.random() * 1000),
  // }));

  useEffect(() => {
    if (data?.data) {
      setQueryResults(data.data);
    }
  }, [data]);

  const handleQuerySubmit = async (e) => {
    e.preventDefault();
    setQueryResults([]); // Clear previous results
    await executeQuery(query);
    setCurrentPage(1);
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        queryResults,
        reasonForCalling,
        questions,
      };

      await submitCallingRequest(payload).unwrap(); // Call RTK Query mutation

      alert("Data submitted successfully!");
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("Failed to submit data.");
    }
  };

  // const handleQuerySubmit = (e) => {
  //   e.preventDefault();
  //   // Mock query execution (replace with actual API call)
  //   const results = players.filter((p) => p.name.toLowerCase().includes(query.toLowerCase()));
  //   setQueryResults(results);
  //   setCurrentPage(1); // Reset to the first page when a new query is executed
  // };

  const handleAddQuestion = () => {
    setQuestions([...questions, ""]);
  };

  const handleQuestionChange = (index, value) => {
    const newQuestions = [...questions];
    newQuestions[index] = value;
    setQuestions(newQuestions);
  };

  const handleLogout = () => {
    dispatch(logoutSuccess());
    navigate("/reporter-login"); // Redirect to login page
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = queryResults.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        {" "}
        {/* Increased width */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h2 style={{ color: "#50868f" }}>Snoword Data Analysis</h2>
          <button
            onClick={handleLogout}
            style={{
              padding: "8px 16px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#50868f",
              color: "#fff",
              fontSize: "16px",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              ":hover": {
                backgroundColor: "#3a6a73",
              },
            }}
          >
            Logout
          </button>
        </div>
        {/* Query Input and Results */}
        <form onSubmit={handleQuerySubmit} style={{ marginBottom: "20px" }}>
          <div style={{ display: "flex", gap: "10px" }}>
            {" "}
            {/* Flexbox for input and button */}
            <input
              type="text"
              placeholder="Enter Query"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              style={{
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #ddd",
                fontSize: "16px",
                outline: "none",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                flex: 1, // Takes remaining space
              }}
            />
            <button
              type="submit"
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#50868f",
                color: "#fff",
                fontSize: "16px",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
                ":hover": {
                  backgroundColor: "#3a6a73",
                },
              }}
            >
              Execute Query
            </button>
          </div>
        </form>
        {/* Query Results */}
        {queryResults.length > 0 && (
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "20px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              marginBottom: "20px",
            }}
          >
            <h3 style={{ color: "#50868f", marginBottom: "10px" }}>
              Query Results
            </h3>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th
                    style={{
                      backgroundColor: "#50868f",
                      color: "#fff",
                      padding: "16px",
                      textAlign: "left",
                    }}
                  >
                    Player ID
                  </th>
                  <th
                    style={{
                      backgroundColor: "#50868f",
                      color: "#fff",
                      padding: "16px",
                      textAlign: "left",
                    }}
                  >
                    Name
                  </th>
                  <th
                    style={{
                      backgroundColor: "#50868f",
                      color: "#fff",
                      padding: "16px",
                      textAlign: "left",
                    }}
                  >
                    Country Code
                  </th>
                  <th
                    style={{
                      backgroundColor: "#50868f",
                      color: "#fff",
                      padding: "16px",
                      textAlign: "left",
                    }}
                  >
                    Phone
                  </th>
                  <th
                    style={{
                      backgroundColor: "#50868f",
                      color: "#fff",
                      padding: "16px",
                      textAlign: "left",
                    }}
                  >
                    Score
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((player) => (
                  <tr key={player.player_id}>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      {player.player_id}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      {player.name}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      {player.country_code}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      {player.phone}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      {player.score}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Pagination */}
            {/* Pagination */}
            {/* Pagination */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "20px",
                flexWrap: "wrap",
                gap: "10px", // Add space between buttons
              }}
            >
              {/* Previous Button */}
              <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor: currentPage === 1 ? "#ccc" : "#50868f",
                  color: "#fff",
                  fontSize: "16px",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  transition: "background-color 0.3s ease",
                }}
              >
                Previous
              </button>

              {/* Page Numbers - Show only 10 at a time */}
              {(() => {
                const totalPages = Math.ceil(
                  queryResults.length / itemsPerPage,
                );
                const maxPageButtons = 10;
                let startPage = Math.max(
                  1,
                  currentPage - Math.floor(maxPageButtons / 2),
                );
                let endPage = Math.min(
                  totalPages,
                  startPage + maxPageButtons - 1,
                );

                if (endPage - startPage < maxPageButtons - 1) {
                  startPage = Math.max(1, endPage - maxPageButtons + 1);
                }

                return Array.from(
                  { length: endPage - startPage + 1 },
                  (_, i) => (
                    <button
                      key={startPage + i}
                      onClick={() => paginate(startPage + i)}
                      style={{
                        padding: "8px 16px",
                        borderRadius: "8px",
                        border: "none",
                        backgroundColor:
                          currentPage === startPage + i ? "#3a6a73" : "#50868f",
                        color: "#fff",
                        fontSize: "16px",
                        cursor: "pointer",
                        margin: "4px",
                        transition: "background-color 0.3s ease",
                      }}
                    >
                      {startPage + i}
                    </button>
                  ),
                );
              })()}

              {/* Next Button */}
              <button
                onClick={() => paginate(currentPage + 1)}
                disabled={
                  currentPage === Math.ceil(queryResults.length / itemsPerPage)
                }
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor:
                    currentPage ===
                    Math.ceil(queryResults.length / itemsPerPage)
                      ? "#ccc"
                      : "#50868f",
                  color: "#fff",
                  fontSize: "16px",
                  cursor:
                    currentPage ===
                    Math.ceil(queryResults.length / itemsPerPage)
                      ? "not-allowed"
                      : "pointer",
                  transition: "background-color 0.3s ease",
                }}
              >
                Next
              </button>
            </div>
          </div>
        )}
        {/* Reason for Calling */}
        <div style={{ marginBottom: "20px" }}>
          <h3 style={{ color: "#50868f", marginBottom: "10px" }}>
            Reason for Calling
          </h3>
          <textarea
            placeholder="Enter reason for calling..."
            value={reasonForCalling}
            onChange={(e) => setReasonForCalling(e.target.value)}
            style={{
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              fontSize: "16px",
              outline: "none",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              width: "100%",
              minHeight: "80px",
              resize: "vertical",
            }}
          />
        </div>
        <div style={{ marginBottom: "20px" }}>
          <h3 style={{ color: "#50868f", marginBottom: "10px" }}>Questions</h3>

          {/* Add More Questions Button at the Top */}
          <button
            onClick={handleAddQuestion}
            style={{
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#50868f",
              color: "#fff",
              fontSize: "16px",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              marginBottom: "10px",
              ":hover": {
                backgroundColor: "#3a6a73",
              },
            }}
          >
            Add More Questions
          </button>

          {/* Questions List */}
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {questions.map((question, index) => (
              <div
                key={index}
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                <input
                  type="text"
                  placeholder="Enter question..."
                  value={question}
                  onChange={(e) => handleQuestionChange(index, e.target.value)}
                  style={{
                    flex: 1,
                    padding: "10px",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    fontSize: "16px",
                    outline: "none",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  }}
                />
                {/* Optional: Add a delete button for each question */}
                <button
                  onClick={() => {
                    const newQuestions = questions.filter(
                      (_, i) => i !== index,
                    );
                    setQuestions(newQuestions);
                  }}
                  style={{
                    padding: "10px",
                    borderRadius: "8px",
                    border: "none",
                    backgroundColor: "#ff6b6b",
                    color: "#fff",
                    fontSize: "16px",
                    cursor: "pointer",
                    transition: "background-color 0.3s ease",
                    ":hover": {
                      backgroundColor: "#ff5252",
                    },
                  }}
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        </div>
        <button
          onClick={handleSubmit}
          style={{
            padding: "10px 20px",
            borderRadius: "8px",
            border: "none",
            backgroundColor: "#50868f",
            color: "#fff",
            fontSize: "16px",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
            width: "100%",
            marginTop: "10px",
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default ReporterLandingPage;
